import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import EmployeeProcessService from "../services/EmployeeProcessService";
import "./MasterData.css"; // <-- Import CSS file

const MasterData = () => {
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState("");
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [showTable, setShowTable] = useState(false);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await EmployeeProcessService.getGetMasterTable();
        if (response.data.statusCode === 200 && response.data.result.length > 0) {
          setOptions(response.data.result);
        } else {
          setOptions([]);
          toast.info("No dropdown options found");
        }
      } catch (error) {
        console.error("Error fetching dropdown options:", error);
        toast.error("Failed to load dropdown options");
      }
    };
    fetchOptions();
  }, []);

  const handleFetchData = async () => {
    if (!selected) {
      toast.info("Please select an option");
      return;
    }
    try {
      const response = await EmployeeProcessService.getGetMastData(selected);
      if (response.data.statusCode === 200 && response.data.result.length > 0) {
        const result = response.data.result;
        setData(result);
        setColumns(Object.keys(result[0] || {}));
        setShowTable(true);
        toast.success("Data loaded");
      } else {
        setData([]);
        setColumns([]);
        setShowTable(false);
        toast.info("No record found");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch data");
    }
  };

  const downloadExcel = () => {
    if (data.length === 0) {
      toast.info("No data to export");
      return;
    }
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${selected || "Data"}.xlsx`);
  };

  return (<>     <div className="mb-1 p-2 bg-light rounded">
    <h7 className="m-0 text-primary">Master Data List</h7>
  </div>
    <div className="master-data-container">

      <div className="controls">
        <select value={selected} onChange={(e) => setSelected(e.target.value)} className="dropdown">
          <option value="">Select Option</option>
          {options.map((opt, idx) => (
            <option key={idx} value={opt.name || opt}>
              {opt.name || opt}
            </option>
          ))}
        </select>
        <button onClick={handleFetchData} className="btn primary">Load Data</button>
        {/* <button onClick={downloadExcel} className="btn secondary">Download Excel</button> */}
      </div>

      {showTable && data.length > 0 && (
        <div className="table-container">
          <table className="styled-table">
            <thead>
              <tr>
                {columns.map((col, i) => (
                  <th key={i}>{col}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row, idx) => (
                <tr key={idx}>
                  {columns.map((col, i) => (
                    <td key={i}>{row[col]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>

          {/* Download button only visible if data is present */}
          <div style={{ marginTop: "15px" }}>
            <button onClick={downloadExcel} className="btn secondary">
              Download Excel
            </button>
          </div>
        </div>
      )}
    </div>
  </>

  );
};

export default MasterData;
